import {
  IncentiveStatusResultTypenames,
  Query,
  QueryIncentiveStatusArgs,
} from '@varo/graphql-schema-types';
import IncentiveStatus from 'services/graphql/queries/Incentive/IncentiveStatus';
import { useQuery } from 'urql';

const useIncentiveStatus = (incentiveProgramId: string) => {
  const [{ data, fetching, error }, reexecuteQuery] = useQuery<
    Query,
    QueryIncentiveStatusArgs
  >({
    query: IncentiveStatus,
    variables: { input: { incentiveProgramId } },
    requestPolicy: 'cache-and-network',
  });

  const result = data?.incentiveStatus;
  const status =
    result?.__typename === IncentiveStatusResultTypenames.IncentiveStatusSuccess
      ? result.status
      : undefined;
  const statusError =
    result?.__typename === IncentiveStatusResultTypenames.IncentiveStatusError
      ? result
      : undefined;

  const refresh = () => {
    reexecuteQuery({ requestPolicy: 'network-only' });
  };

  return { status, fetching, error, statusError, refresh };
};

export default useIncentiveStatus;
